import { combineReducers } from "@reduxjs/toolkit";
import createReducer from "./createReducer";

const reducer = combineReducers({
  create: createReducer,
});

export { reducer };
